var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-scroll py-3"},[_c('div',{staticClass:"w-full md:w-3/4 mx-auto mb-6"},[(_vm.upload)?_c('input-image',{attrs:{"language":_vm.language,"label":"Upload","upload-route":_vm.uploadRoute},on:{"uploaded":(file) => {
                return _vm.media.unshift(file)
            }}}):_vm._e()],1),_vm._v(" "),_c('media-library',{attrs:{"media-data":_vm.media,"editable":_vm.upload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }